//Componentes generales
import React, { useReducer, useEffect } from "react";
import agregarReqReducer from "./agregarReqReducer";
import agregarReqContext from "./agregarReqContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { addFiles, addTransactionDocument, addTransactionDocumentDirect, addTransactionDocumentFromProcs, addTransactionDocumentsFromCtrlsFallidos, deleteFile, updateTDoc } from "../../api/transactionDocuments";
import { getAbmProduct, getAbmProductByTDoc } from "../../api/abmProduct";
import { updateListProductByTDoc } from "../../api/product";

//Acciones
import { 
    CARGAR_ITEM,
    MODIFICAR_REQ,
    CARGAR_REQ,
    SELECCIONAR_PRODUCTO,
    ELIMINAR_ITEM,
    MODIFICAR_ITEM,
    SELECCIONAR_ITEM,
    CARGAR_PRODUCTOS,
    GUARDAR_REQUERIMIENTO,
    CARGANDO_ADD,
    ERROR_ADD,
    SELECCIONAR_FILE,
    ELIMINAR_FILE,
    ERROR,
    LIMPIAR_ERROR
} from "./agregarReqActions";
import { icon } from "@fortawesome/fontawesome-svg-core";
import Swal from "sweetalert2";

/* 
    State encargado de la llamada al backend para agregar un nuevo requerimiento.
*/
const AgregarReqState = props => {

    //Valores inciales
    const initialState = {
       req: {
            title: "",
            observ: "",
            deliveryDate: new Date(),
            priority: 0,
            dateOfIssue: new Date()
       },
       files: [],
       itemsList: [],
       products: [],
       productSelected: null,
       itemSelected: null,
       modReq: false,
       cargando: false,
       error: ""
    };

    const [state, dispatch] = useReducer(agregarReqReducer, initialState);

    /* 
        Función que actualiza la lista de productos.
    */
    const actualizarProducts = async () => {

        try{

            const resp = await getAbmProduct();

            dispatch({
                type: CARGAR_PRODUCTOS,
                payload: resp.data.data
            })

        }catch(error){
            console.log(error);
        }
    }

    /*
        Función encargada de cargar el requerimiento.
            Donde req es el requerimiento a cargar.
        Actualmente no esta en uso.
    */
    const cargarRequerimiento = (req) => {
        dispatch({
            type: CARGAR_REQ,
            payload: req
        })
    }

    /* 
        Función que selecciona un producto.
            Donde product es el producto.
    */
    const seleccionarProducto = (product) => {
        dispatch({
            type: SELECCIONAR_PRODUCTO,
            payload: product
        })
    }

    /* 
        Función que carga un item.
            Donde item es el item a cargar.
    */
    const cargarItem = (item) => {
        dispatch({
            type: CARGAR_ITEM,
            payload: item 
        })
    }

    /* 
        Función elimina un item.
            Donde index es la posición del item a eliminar.
    */
    const eliminarItem = (index) => {
        dispatch({
            type: ELIMINAR_ITEM,
            payload: index
        })
    }

    /* 
        Función que modifica un item.
            Donde index es la posición del item a modificar.
                  nuevoItem es el item modificado.
    */
    const modificarItem = (index, nuevoItem) => {
        dispatch({
            type: MODIFICAR_ITEM,
            payload: {
                index,
                item: nuevoItem
            }
        })
    }

    /* 
        Función que selecciona el item.
            Donde item es el item a seleccionar.
    */
    const seleccionarItem = (item) => {
        dispatch({
            type: SELECCIONAR_ITEM,
            payload: item
        })
    }

    /* 
        Función que modifica un requerimiento.
            Donde modificar es el requerimiento modificado.
    */
    const modificarRequerimiento = (modificar) => {
        dispatch({
            type: MODIFICAR_REQ,
            payload: modificar
        })
    }

    /* 
        Función encargada de guardar un requerimiento.
            Donde requeriment es el requerimiento a guardar.
                  items son los items/productos del requerimiento a guardar.
                  user es el usario en sesión.
                  files son los archivos adjuntado a un requerimiento.
    */
        const guardarRequerimiento = async (requeriment, items, user, files) => {
        try{
            const tDoc = {...requeriment, quantity: (items != undefined) ? items.length : 0, tDocUserID: user._id, userName: user.userName}; 
            const resp = await addTransactionDocument(tDoc, (items != undefined) ? items : []); //clienteAxios.post(`/transactionDocument`,{transactionDocument: tDoc, products: items});
            if(files.length > 0) await agregarArchivos(resp.data.data, files);
            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            return resp.data.data;
        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR,
                payload: error.msg
            })
        }
    }
    /*
        Guarda una ODT generada sobre procedimientos programados. El backend crea la ODT y vincula los procs
        en el mismo request, con rollback si algo falla.
        Retorna {status, data} o {status:false, msg}.
    */
        const guardarRequerimientoFromProcs = async (requeriment, items, user, files, procsProgramados) => {
        try{
            const tDoc = {...requeriment, quantity: (items != undefined) ? items.length : 0, tDocUserID: user._id, userName: user.userName};
            const procs = procsProgramados.map(p => ({_id: p._id, activoID: p.activoID, procedimientoID: p.procedimientoID, originado: p.originado, codProc: p.codProc}));
            const resp = await addTransactionDocumentFromProcs(tDoc, (items != undefined) ? items : [], procs);
            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            try {
                if(files.length > 0) await agregarArchivos(resp.data.data, files);
            } catch (error) {
                return {status: true, data: resp.data.data, msg: `La ODT ${resp.data.data.tDocNroFor} se guardó, pero hubo un error al subir los archivos adjuntos.`};
            }
            return {status: true, data: resp.data.data};
        }catch(error){
            console.log(error);
            return {status: false, msg: error?.response?.data?.message ?? 'Hubo un error desconocido al intentar guardar la orden de trabajo'};
        }
    }
    /*
        Crea un procedimiento directo y su ODT en un mismo request. El backend vincula ambos y hace rollback si algo falla.
        Retorna {status, data} o {status:false, msg}.
    */
        const guardarRequerimientoDirecto = async (requeriment, items, user, procProgramado, activo) => {
        try{
            const tDoc = {...requeriment, products: (items != undefined) ? items : [], quantity: (items != undefined) ? items.length : 0, tDocUserID: user._id, userName: user.userName};
            const resp = await addTransactionDocumentDirect(tDoc, procProgramado, activo);
            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            return {status: true, data: resp.data.tDoc};
        }catch(error){
            console.log(error);
            return {status: false, msg: error?.response?.data?.message ?? 'Hubo un error desconocido al intentar guardar la orden de trabajo'};
        }
    }
    /*
        Crea las ODTs de controles fallidos distribuidos en el modal. El backend las crea y vincula a sus procs
        en un mismo request, todo o nada.
        Retorna {status, data: tDocs[]} o {status:false, msg}.
    */
        const guardarRequerimientosFromCtrlsFallidos = async (procOriginal, ordenesTrabajo, procTemplate, user) => {
        try{
            const tDocs = ordenesTrabajo.map(ot => ({...ot, products: [], quantity: 0, tDocUserID: user._id, userName: user.userName}));
            const proc = {_id: procOriginal._id, activoID: procOriginal.activoID, procedimientoID: procOriginal.procedimientoID, originado: procOriginal.originado, codProc: procOriginal.codProc};
            const resp = await addTransactionDocumentsFromCtrlsFallidos(proc, tDocs, procTemplate);
            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            return {status: true, data: resp.data.data};
        }catch(error){
            console.log(error);
            return {status: false, msg: error?.response?.data?.message ?? 'Hubo un error desconocido al intentar guardar las ordenes de trabajo'};
        }
    }
        const guardarConsumo = async (requeriment, user) => {
        try{
            const tDoc = {...requeriment, codFor:'CONS', quantity: (requeriment.productos != undefined) ? requeriment.productos.length : 0, tDocUserID: user._id, userName: user.userName}; 
            const resp = await addTransactionDocument(tDoc, (requeriment.productos != undefined) ? requeriment.productos : []);
            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            return resp.data.data;
        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR,
                payload: error.msg
            })
        }
    }

    /* 
        Función que edita un requerimiento.
            Donde tDoc es el requerimiento modificado.
                  productList son los items del requerimiento modificado.
                  files son los archivos adjuntados al requerimiento modificado.
                  filesBase son los archivos que tenia antes de la modificación.
                  usuario es el usuario en sesión.
    */
    const editarRequerimientoBE = async (tDoc, productList, files, filesBase, usuario, fromAction = 'normal') => {
        try {
            const {products,...tDocToEdit} = tDoc;
            tDoc.productos = tDoc?.productos?.filter(p => p.tipPro != '');
            let tdoc = await updateTDoc(tDoc, {...tDoc, quantity: productList.length}, usuario);
            
            if(fromAction == 'normal'){
                //Actualizar los archivos
                const filesToUpload = files.filter(f => f.accion == 'ADD');
                const filesToDelete = files.filter(f => f.accion == 'DELETE');
                
                if(filesToUpload.length > 0) await agregarArchivos(tDoc, filesToUpload);
                if(filesToDelete.length > 0) await eliminarArchivos(tDoc, filesToDelete);
            }else{
                if(files?.length > 0) await agregarArchivos(tDoc, files);
            }

            dispatch({
                type: GUARDAR_REQUERIMIENTO
            });
            return tdoc.data.data;
        } catch (error) {
            console.log("error en editarRequerimientoBe");
            console.log(error);
            Swal.fire({
                icon:'error',
                title:'Ops!',
                text: error.response?.data?.message
            })
            dispatch({
                type: ERROR_ADD,
                payload: error.message
            });
            return false;
        }
    }

    /* 
        Función para carga.
        No esta en uso.
    */
    const cargando = async  () => {
        dispatch({
            type: CARGANDO_ADD
        })
    }
    
    /* 
        Función que selecciona un archivo.
    */
    const seleccionarFile = async () => {
        try {
            const fileUpload = null
            if(fileUpload.name !== undefined){
                dispatch({
                    type: SELECCIONAR_FILE,
                    payload: fileUpload
                });
            }
        } catch (error) {
        }
    }

    /* 
        Función que eliminar un archivo.
            Donde fle es el archivo a eliminar.
    */
    const eliminarFile = (file) => {
        console.log(file);
        dispatch({
            type: ELIMINAR_FILE,
            payload: file
        });
    }

    /* 
        Función que limpia el valor de error.
    */
    const limpiarError = async () => {
        dispatch({
            type: LIMPIAR_ERROR,
        });
    }

    return(
        <agregarReqContext.Provider
            value={{
                req: state.req,
                modReq: state.modReq,
                itemsList: state.itemsList,
                products: state.products,
                productSelected: state.productSelected,
                itemSelected: state.itemSelected,
                isCargando: state.cargando,
                error: state.error,
                cargarRequerimiento,
                modificarRequerimiento,
                seleccionarProducto,
                cargarItem,
                eliminarItem,
                modificarItem,
                seleccionarItem,
                actualizarProducts,
                guardarRequerimiento,
                guardarRequerimientoFromProcs,
                guardarRequerimientoDirecto,
                guardarRequerimientosFromCtrlsFallidos,
                guardarConsumo,
                cargando,
                seleccionarFile,
                eliminarFile,
                limpiarError,
                editarRequerimientoBE
            }
        }>

            {props.children}

        </agregarReqContext.Provider>
    )
}

export default AgregarReqState;

/* 
    Actualmente no esta en uso.
*/
const toFileUpload = (file) => {
    let { name, mimeType, size, uri } = file;

    let fileToUpload = {
        name: name,
        size: size,
        uri: uri,
        type: mimeType
    };
    return fileToUpload;
}

/* 
    Agrega archivos a un requerimiento.
        Donde req es el requerimiento.
              files son los archivos.
*/
const agregarArchivos = async (req, files) => {
    try {
        const formData = new FormData();
        files.map((f, i) => {
            formData.append(`files`, f.dato);
        });
        formData.append('prefijo', `${req.tDocCodFor + "-" + req.tDocNroFor}`);
        await addFiles(formData);
        return true;
    } catch (error) {
        console.log("Error en agregar archivos");
        console.log(error);
        throw new Error(`Error al guardar archivos del requerimiento ${req.tDocCodFor + "-" + req.tDocNroFor}`)
    }
}

/* 
    Función que compara los archivos que se estan viendo contra los archivos de la base de datos y decide que hacer.
        Donde listaState son los archivos actuales.
              listaBD son los archivos de la base de datos.
*/
const compararListaFiles = (listaState, listaBD) => {
    const result = {
        "agregar": [],
        "eliminar": []
    }

    if(listaBD.length === 0 && listaState.length > 0) result.agregar = listaState;
    else if(listaState.length === 0 && listaBD.length > 0) result.eliminar = listaBD;

    else if(listaState.length !== 0 && listaBD.length !== 0){
        listaBD.map((fbd) => {if(listaState.findIndex((fs) => fs.name === fbd.name) === -1) result.eliminar.push(fbd); });
        listaState.map((fs) => {if(listaBD.findIndex((fbd) => fbd.name === fs.name) === -1) result.agregar.push(fs); });
    }
    return result;
}

/* 
    Función que elimina archivos.
        Donde listaFiles son los archivos a eliminar.
*/
const eliminarArchivos = async (tDoc,listaFiles) => {
    try{
        console.log("listaFiles en eliminarArchivos de agregarReqState");
        console.log(listaFiles);
        
        for (const file of listaFiles) await deleteFile(file.name); 
    }catch(error){
        console.log(error);
        throw new Error(`Error al eliminar archivos`)
    }
}